import { render, staticRenderFns } from "./WorkplaceSafety.vue?vue&type=template&id=16afc404&scoped=true&"
import script from "./WorkplaceSafety.vue?vue&type=script&lang=js&"
export * from "./WorkplaceSafety.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceSafety.vue?vue&type=style&index=0&id=16afc404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afc404",
  null
  
)

export default component.exports